module.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjE0IiB2aWV3Qm94PSIwIDAgOSAxNCIgd2lkdGg9IjkiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09Im1hdHJpeCguNzA3MTA2NzggLjcwNzEwNjc4IC0uNzA3MTA2NzggLjcwNzEwNjc4IDIgLS4wNzEwNjgpIj48cGF0aCBkPSJtMCAwaDEwdjJoLTEweiIvPjxwYXRoIGQ9Im00IDRoMTB2MmgtMTB6IiB0cmFuc2Zvcm09Im1hdHJpeCgwIDEgLTEgMCAxNCAtNCkiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow.svg
// module id = 7/y1
// module chunks = 1